import type { PerimeterSearchApi } from "@App/apis/graphql/perimeterSearch/interfaces";
import { PerimeterSearchService } from "@App/apis/graphql/perimeterSearch/v1/perimeterSearchService";
import { createContext } from "react";

/**
 * Context for managing perimeter search-related data and operations.
 *
 * This context provides an instance of the `PerimeterSearchApi` interface,
 * which defines the methods and properties for interacting with perimeter search data.
 * By default, it uses the `PerimeterSearchService` V1 implementation.
 *
 * Usage:
 * - Wrap your component tree with a `Provider` for this context to supply
 *   the perimeter search service to your components.
 * - Use `useContext(PerimeterSearchContext)` to access the service in your components.
 */
export const PerimeterSearchContext = createContext<PerimeterSearchApi>(
  new PerimeterSearchService(),
);
